import api from '../config/api';
import { to } from '../utils/async';
import KRService from './krs';

export const applyCommentCountToKeyResults = (
  krs,
  commentCountMap
) => {
  return krs.map((kr) => {
    const updatedKr = { ...kr };
    updatedKr.commentCount = commentCountMap[kr.id];

    if (updatedKr.nestedKrs) {
      updatedKr.nestedKrs = applyCommentCountToKeyResults(
        updatedKr.nestedKrs,
        commentCountMap,
      );
    }

    return updatedKr;
  });
};

export const filterClosedKRs = (krs) => {
  return krs.filter((kr) => kr?.openCloseStatus == 1);
};

export const filterEmptyTeamName = (krs) => {
  return krs.filter((kr) => kr?.teamName);
};

export const filterEmptyTeamId = (krs) => {
  return krs.filter((kr) => kr?.teamId);
};

export const filterClosedOKRs = (okrs) => {
  return okrs.filter((okr) => okr?.status === 1);
};

const OkrService = {
  getObjectives: async (props) => {
      const { type, teamId } = props || { type: 'personal', teamId: '' };
      const URL = `${wbConfig.baseUrl}/vnext/okr/objectives`;
      const params = {
        type,
        ...(teamId ? {teamId} : {}),
        page: 0,
        pageSize: 30,
        includeOpenOKRs: false,
        includeClosedOKRs: false,
      };

      try {
        const [err, result] = await to(api.get(URL, { params }));
        if (err) {
          console.error('Error fetching Objectives', err);
          return [err, null];
        }
        return [null, result.data.data];
        
      } catch (error) {
        console.error('Error fetching Objectives', error);
        toastr.error('Error fetching Objectives');
      }
      
  },
  getObjectivesByUserId: async ({ userId }) => {
    const URL = `${wbConfig.baseUrl}/vnext/okr/objectives/byfilter`;
      const params = {
        userId,
      };

      try {
        const [err, result] = await to(api.get(URL, { params }));
        if (err) {
          console.error('Error fetching Objectives by User', err);
          return [err, null];
        }
        const filteredOkrs = filterClosedOKRs(result.data);
        return [null, filteredOkrs];
        
      } catch (error) {
        console.error('Error fetching Objectives by User', error);
        toastr.error('Error fetching Objectives by User');
      }

  },
  getObjectivesPermissionsById: async ({ id }) => {
    const URL = `${wbConfig.baseUrl}/vnext/okr/objectives/${id}/permissions`;
      const params = {
        id,
      };

      try {
        const [err, result] = await to(api.get(URL, { params }));
        if (err) {
          console.error('Error fetching Objectives Permissions by OKR ID', err);
          return [err, null];
        }
        return [null, result.data];
        
      } catch (error) {
        console.error('Error fetching Objectives Permissions by OKR ID', error);
        toastr.error('Error fetching Objectives Permissions by OKR ID');
      }

  },
  getKeyResults: async () => {
    const URL = `${wbConfig.baseUrl}/vnext/okr/keyResults`;
    const params = {
      status: 'all',
      page: 0,
      pageSize: 30,
      includeOpenOKRs: false,
      includeClosedOKRs: false,
    };

    try {
      const [err, result] = await to(api.get(URL, { params }));
      if (err) {
        console.error('Error fetching KeyResults', err);
        return [err, null];
      }
      return [null, result.data.data];
      
    } catch (error) {
      console.error('Error fetching KeyResults', error);
      toastr.error('Error fetching KeyResults');
    }
    
  },
  getObjectivesKeyResults: async ({ userId, okr, krType }) => {
    const okrId = okr.id;
    const URL = `${wbConfig.baseUrl}/vnext/okr/objectives/${okrId}/keyresults`;
      const params = {
        userId,
      };

      try {
        const [err, response] = await to(api.get(URL, { params }));
        if (err) {
          console.error('Error fetching Objectives Key Results by OKR and User ID', err);
          return [err, null];
        }
        const filteredClosedKrs = filterClosedKRs(response.data);
        let filteredPersonalKrs = filteredClosedKrs;
        if (krType === 'team') {
          filteredPersonalKrs = okr.teamName ? filteredClosedKrs : [];
        }
        const krIds = filteredClosedKrs.map((kr) => kr.id);
        const commentCountResp = await KRService.fetchMultipleKrCommentCount(krIds);
        const krs = applyCommentCountToKeyResults(filteredPersonalKrs, commentCountResp);

        return [null, krs];
        
      } catch (error) {
        console.error('Error fetching Objectives Key Results by OKR and User ID', error);
        toastr.error('Error fetching Objectives Key Results by OKR and User ID');
      }
  },
  getKeyResultsByUserId: async ({ userId }) => {
    const URL = `${wbConfig.baseUrl}/vnext/okr/keyresults/byfilter`;
      const params = {
        userId,
      };

      try {
        const [err, result] = await to(api.get(URL, { params }));
        if (err) {
          console.error('Error fetching KeyResults by User', err);
          return [err, null];
        }
        const filteredClosedKrs = filterClosedKRs(result.data);
        const filteredPersonalKrs = filterEmptyTeamId(filteredClosedKrs);
        return [null, filteredPersonalKrs];
        
      } catch (error) {
        console.error('Error fetching KeyResults by User', error);
        toastr.error('Error fetching KeyResults by User');
      }
  },
  getMeetingObjectives: async (params) => {
    const URL = `/wb/adminActivity/getMeetingObjectives`;
    try {
      const [err, result] = await to(api.get(URL, { params }));
      if (err) {
        console.error('Error fetching getMeetingObjectives', err);
        return [err, null];
      }
      return [null, result.data?.goals];
        
    } catch (error) {
      console.error('Error fetching getMeetingObjectives', error);
      toastr.error('Error fetching getMeetingObjectives');
    }
  },
  getMeetingKeyResults: async (params) => {
    const URL = `/wb/adminActivity/getMeetingKeyResults`;
    try {
      const [err, result] = await to(api.get(URL, { params }));
      if (err) {
        console.error('Error fetching getMeetingKeyResults', err);
        return [err, null];
      }

      const keyResults = result.data?.keyResults;
      const krIds = keyResults.map((kr) => kr.id);
      const commentCountResp = await KRService.fetchMultipleKrCommentCount(krIds);
      const krsWithCommentCount = applyCommentCountToKeyResults(keyResults, commentCountResp);

      return [null, krsWithCommentCount];
        
    } catch (error) {
      console.error('Error fetching getMeetingKeyResults', error);
      toastr.error('Error fetching getMeetingKeyResults');
    }
  },
}

export default OkrService;
